import { render, staticRenderFns } from "./EditPartnership.vue?vue&type=template&id=48e5e886"
import script from "./EditPartnership.vue?vue&type=script&lang=js"
export * from "./EditPartnership.vue?vue&type=script&lang=js"
import style0 from "./EditPartnership.vue?vue&type=style&index=0&id=48e5e886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports